import React, { useEffect, useRef } from 'react';
import Helmet from 'react-helmet';

declare global {
    interface Window {
        // eslint-disable-next-line
        Trustpilot?: any;
    }
}

export type TTrustpilotTemplate = 'feed' | 'horizontal' | 'score' | 'micro' | 'microCombo';
export type TTemplateTheme = 'light' | 'dark';

export interface ITemplateConfig {
    id: string;
    height: string;
}

export interface ITrustpilotAttributes {
    className: string;
    [`data-template-id`]: string;
    ['data-locale']: string;
    ['data-businessunit-id']: string;
    ['data-style-height']: string;
    ['data-style-width']: string;
    ['data-stars']: string;
    ['data-theme']: TTemplateTheme;
    ['data-review-languages']: string;
}

const TEMPLATE_MAP: Record<TTrustpilotTemplate, ITemplateConfig> = {
    feed: { id: '539adbd6dec7e10e686debee', height: '500px' },
    horizontal: { id: '5406e65db0d04a09e042d5fc', height: '25px' },
    score: { id: '53aa8807dec7e10d38f59f32', height: '120px' },
    micro: { id: '5419b732fbfb950b10de65e5', height: '20px' },
    microCombo: { id: '5419b6ffb0d04a076446a9af', height: '20px' },
};

export interface ITrustpilotProps {
    template: string;
    theme?: TTemplateTheme;
    stars?: string;
}

export const Trustpilot = ({ template = 'score', theme = 'light', stars = '4,5' }: ITrustpilotProps): JSX.Element => {
    const config = TEMPLATE_MAP[template as TTrustpilotTemplate] as ITemplateConfig | undefined;

    // if window.Trustpilot is available, load the trustbox
    const ref = useRef(null);
    useEffect(() => {
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(ref.current, true);
        }
    }, []);

    const attributes: ITrustpilotAttributes = {
        className: 'trustpilot-widget',
        'data-template-id': `${config?.id}`,
        'data-locale': 'en-GB',
        'data-businessunit-id': '5a822000a52f5b000108b29b',
        'data-style-height': `${config?.height}`,
        'data-style-width': '100%',
        'data-stars': stars,
        'data-theme': theme,
        'data-review-languages': 'en',
    };

    return (
        <>
            <Helmet>
                <script
                    type="text/javascript"
                    src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
                    async
                ></script>
            </Helmet>
            <div ref={ref} {...attributes}>
                <a href="https://uk.trustpilot.com/review/www.oddbox.co.uk" target="_blank" rel="noreferrer" />
            </div>
        </>
    );
};
